import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

const View = () => {
  return (
    <Box data-testid="top-coins-loading" className="py-6 text-center">
      <CircularProgress />
    </Box>
  )
}

export default View
